import { Fragment } from "react";
import { Dialog, Transition } from "@headlessui/react";

/**
 * @name SimpleModal - 定義 Modal 外框
 * @param {boolean} open - 顯示 Modal 開關與否
 * @param {function} setOpen - 控制 Modal 開關的狀態
 * @param {function(): *} Content - 顯示於 Modal 內容
 */

export const SimpleModal = ({ open, setOpen, Content }) => {
	return (
		<Transition.Root show={open} as={Fragment}>
			<Dialog as="div" className="relative z-10" onClose={setOpen}>
				<Transition.Child
					as={Fragment}
					enter="ease-out duration-300"
					enterFrom="opacity-0"
					enterTo="opacity-100"
					leave="ease-in duration-200"
					leaveFrom="opacity-100"
					leaveTo="opacity-0"
				>
					<div className="fixed inset-0 bg-[#c9c9c9] bg-opacity-65 transition-opacity" />
				</Transition.Child>

				<div className="fixed inset-0 z-10 w-screen overflow-y-auto">
					<div className="flex max-h-full min-h-full items-center justify-center p-4 text-center">
						<Transition.Child
							as={Fragment}
							enter="ease-out duration-300"
							enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
							enterTo="opacity-100 translate-y-0 sm:scale-100"
							leave="ease-in duration-200"
							leaveFrom="opacity-100 translate-y-0 sm:scale-100"
							leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
						>
							<Dialog.Panel className="relative w-full max-w-[437px] overflow-hidden bg-white p-6 text-left shadow-xl transition-all sm:my-8">
								<button
									className={"absolute right-4 top-4 h-3 w-3 sm:h-4 sm:w-4"}
									onClick={() => setOpen(false)}
								>
									<img
										alt={"x-icon"}
										src={window.assetUrl("/images/liff/X.png")}
										className={"h-3 w-3 sm:h-4 sm:w-4"}
									/>
								</button>
								{Content}
							</Dialog.Panel>
						</Transition.Child>
					</div>
				</div>
			</Dialog>
		</Transition.Root>
	);
};
